import React from 'react'
import { Link } from 'gatsby'

import Fade from 'react-reveal/Fade'

class ArticleCard extends React.Component {
  render() {
    const heroImageThumb = this.props.article.heroImageThumbnail
      ? this.props.article.heroImageThumbnail.file.url
      : this.props.article.heroImage.file.url

    // Old version - the Category is tagged as the Series name
    // keep in case client wants to switch back
    // const category =
    //   this.props.showFeaturedSeriesCategory && this.props.article.featuredPage
    //     ? this.props.article.featuredPage.title
    //     : this.props.article.category
    //       ? this.props.article.category.title
    //       : null

    const category = this.props.article.category.title

    const linkTitle = 'Navigate to: ' + this.props.article.title

    return (
      <div className="landing__article-card">
        <Fade>
          <Link title={linkTitle} to={`/articles/${this.props.article.slug}/`}>
            <div className="article-card__image-wrapper">
              <div
                className="article-card__image"
                style={{
                  backgroundImage: `url(${heroImageThumb}?fm=jpg&q=90)`,
                }}
              />
            </div>
          </Link>

          <div className="article-card__content-wrapper">
            <div className="article-card__category" style={null}>
              {category}
            </div>

            <Link
              title={linkTitle}
              to={`/articles/${this.props.article.slug}/`}
              className="article-card__title"
            >
              {this.props.article.title}
            </Link>
            <div className="article-card__teaser">
              {this.props.article.shortDescription}
            </div>
          </div>
        </Fade>
      </div>
    )
  }
}
export default ArticleCard
